module.exports = __webpack_public_path__ + "img/full1-min.4677dcc9.png";